module.exports = __webpack_public_path__ + "static/media/icon_minato50428c5ada2f406a1cd3b494b2ff9e4b.webp";